<template src="../templates/dynamicBookingDetail.html"></template>

<script>
    import BookingModel from "../models/bookingModel";
    import BookingEditModel from "../models/bookingEditModel";
    import moment from 'moment';
    import TimePicker from "./TimePickerCompomponent";
    import DynamicCaldsComponent from "./DynamicCaldsComponent";
    import {EventBus} from "../event-bus";

    export default {
        name: "DynamicBookingDetail",
        data() {
            return {
                dynamicComponent: {
                    components: {TimePicker},
                    data() {
                        return {
                            isInEditMode: this.isInEditModeProp,
                            saveChanges: this.saveChangesProp
                        }
                    },
                    template: "<div></div>",


                },
                message: "",
                hasError: false,

            }
        },
        props: {
            bookingId: {
                type: Number
            },
            isInEditModeProp: {
                type: Boolean,
                required: true
            },
            saveChangesProp: {
                type: Boolean,
                required: true
            }
        },
        watch: {
            isInEditModeProp(val) {
                this.$emit('onEditModeChanged', val);
            },
            saveChangesProp(val) {
                console.log(val + "save");
                this.$emit('saveChanges', val);
            }

        },
        methods: {
            actions() {

                let self = this;
                let url = this.$localApiURL + 'layout/12?token=' + localStorage.getItem("jwt");
                this.$http.get(url, {
                    headers: {"Bearer": localStorage.getItem("jwt")}
                }).then(result => {

                        this.dynamicComponent = {
                            components: {TimePicker, DynamicCaldsComponent},
                            data() {
                                return {
                                    bookingModel: new BookingModel(),
                                    bookingEditModel: new BookingEditModel(),
                                    otherInfoLabelName: "",
                                    isInEditMode: false,
                                    saveChanges: false,
	                                requestChangeInfo: "All Graduates booking team will contact you shortly to advise if your request can be accepted."
                                }
                            },

                            methods: {
                                setEditMode(val) {
                                    this.isInEditMode = val;
                                    if (this.isInEditMode) {
                                        this.bookingEditModel.ref_num = this.bookingModel.ref_num;
                                        this.bookingEditModel.serviceDate = this.bookingModel.serviceDate;
                                        this.bookingEditModel.serviceTimeStart = this.bookingModel.serviceTimeStart;
                                        this.bookingEditModel.serviceTimeEnd = this.bookingModel.serviceTimeEnd;
                                        this.bookingEditModel.location_address1 = this.bookingModel.location_address1;
                                        this.bookingEditModel.clinic_ward = this.bookingModel.clinic_ward;
                                        this.bookingEditModel.requested_by = this.bookingModel.requested_by;
                                        this.bookingEditModel.nesbs = this.bookingModel.nesbs;
                                    }
                                },
                                requestChanges() {

                                    if (!this.isInEditMode) {
                                        let data =
                                            {
                                                startTime: (this.$refs.startTime) ? this.$refs.startTime.value : "",
                                                endTime: (this.$refs.endTime) ? this.$refs.endTime.value : "",
                                                location: (this.$refs.location) ? this.$refs.location.value : "",
                                                requestedBy: (this.$refs.requestedBy) ? this.bookingEditModel.requested_by : "",
                                                nesbs: (this.$refs.caldsForm != null && this.$refs.caldsForm.tempCaldsModel != null) ? this.$refs.caldsForm.tempCaldsModel.nesbs : []
                                            };
                                        let url = this.$localApiURL + "jobs/changes/requestChange";
                                        let self = this;
                                        this.$http.post(url,
                                            {
                                            	data: {
		                                            existing: this.bookingModel,
		                                            change_requested: data
												},
                                                token: localStorage.getItem("jwt")
                                            })
                                            .then(function (response) {
                                                if (response != null && response.data != null) {
                                                    if (response.data.error === "") {
	                                                    self.$alert(self.requestChangeInfo, 'Thanks for your change request', {
		                                                    type: 'info',
		                                                    dangerouslyUseHTMLString: true,
		                                                    confirmButtonText: 'OK',
		                                                    center: true
	                                                    });
                                                    } else {
                                                        self.$message.error("Error sending the change request, please contact allgraduates");
                                                    }
                                                }

                                                console.log(response);
                                            }).catch(function (error) {
                                            console.log(error);
                                        });
                                    }
                                },
                                date: function (value, format) {
                                    if (value) {
                                        return moment(String(value)).format(format || 'D MMMM YYYY')
                                    }
                                },
                                getFullAddress() {
                                    let fullAddress = "";
                                    return fullAddress.concat(
                                        (this.bookingModel.location_address1 ? this.bookingModel.location_address1 : ""), " ",
                                        (this.bookingModel.location_address2 ? this.bookingModel.location_address2 : ""), " ",
                                        (this.bookingModel.clinic_ward ? this.bookingModel.clinic_ward : ""), " ",
                                        (this.bookingModel.suburb ? this.bookingModel.suburb : ""), " ",
                                        (this.bookingModel.postCode ? this.bookingModel.postCode : ""));

                                },
                                getBookingData() {

                                    let current = this;
                                    current.$parent.$emit("loadingDetails");
                                    let url = this.$localApiURL + this.bookingModel.getRoute("fetch") + self.bookingId;
                                    this.bookingModel.fetch({
                                        'url': url,
                                        params: {
                                            token: localStorage.getItem('jwt')
                                        }
                                    }).then((res) => {
                                            current.otherInfoLabelName = res.response.data.other_info ? "Other Info" : "";
                                            current.$parent.$emit("detailsLoaded");
                                        }
                                    ).catch((error) => {
                                        console.error(error);
                                    });
                                }
                            },
                            created() {
                                this.getBookingData();
                                this.$parent.$on('onEditModeChanged', this.setEditMode);
                                this.$parent.$on('saveChanges', this.requestChanges);
                            },
                            template: result.data,
                        }
                    }
                ).catch(function (error) {
                    console.error(error);
                });
            }
        },
        created() {
            this.actions();
        }
    }
</script>

<style lang="scss">

    @import '../assets/scss/general.scss';

    .myDynamicBookingDetail {

        margin: 20px 0;

        .el-card__header {
            background: $myColor-card-header;
            border: 1px solid $myColor-card-header-border;
            padding: 20px !important;
            border-radius: 5px 5px 0 0;

            h4 {
                margin: 0;
            }
        }

        .el-card__body {
            border: 1px solid $myColor-card-header-border;
            border-top: 0;
            border-radius: 0 0 3px 3px;
            padding: 20px;
        }

        p {
            margin: 0 !important;
        }

		label {
			margin: 0 !important;
		}

		.el-form-item {
			padding: 0 !important;
		}

		.el-row {
			border-bottom: 1px solid whitesmoke !important;
		}
    }

	.defaultOverride {

		margin: 20px 0;

		.el-card__header {
			background: $myColor-card-header;
			border: 1px solid $myColor-card-header-border;
			padding: 20px !important;
			border-radius: 5px 5px 0 0;

			h4 {
				margin: 0;
			}
		}

		.el-card__body {
			border: 1px solid $myColor-card-header-border;
			border-top: 0;
			border-radius: 0 0 3px 3px;
			padding: 20px;
		}

		p {
			margin: 0 !important;
		}

		label {
			margin: 0 !important;
		}

		.el-form-item {
			padding: 0 !important;
		}

		.el-row {
			border-bottom: 1px solid whitesmoke !important;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/DynamicBookingDetail.vue